import React from "react";
import { useI18n } from "../i18n/I18nProvider";

const LOGOS = [
  "Impact Light Studio", "Atlantic Craft", "Noir Goods", "Café Indulgent",
  "Tourism NB", "Mapei", "Rabat FC", "Studio Ilyas",
  "Cajun Seafood", "Phaneroo Ventures", "Mont-Royal", "North Road",
];

export default function Marquee() {
  const { lang } = useI18n();
  return (
    <section className="py-16 border-y border-hair bg-[#070708] overflow-hidden" data-testid="trusted-marquee">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10 mb-8">
        <div className="text-[11px] tracking-[0.28em] uppercase text-ink-500">
          {lang === "fr" ? "Marques qui nous font confiance" : "Trusted by"}
        </div>
      </div>
      <div className="relative">
        <div className="flex w-max marquee-track gap-16 px-6">
          {[...LOGOS, ...LOGOS].map((name, i) => (
            <div key={i} className={`font-serif-editorial italic text-2xl md:text-3xl whitespace-nowrap transition-opacity ${
              name === "Impact Light Studio" ? "text-ink-100 opacity-100" : "text-ink-300 opacity-80 hover:opacity-100"
            }`}>
              {name}
              <span className="mx-8 text-rouge">·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
